import { api } from '../api';

// Qué tira alumbra cada ubicación, recordado un momento.
//
// POR QUÉ EXISTE. Un pasillo entero de resultados de búsqueda pregunta por
// la MISMA ubicación. Sin esto, una lista de veinte renglones dispara
// veinte peticiones idénticas solo para decidir si pinta un botón.
//
// POR QUÉ DURA TAN POCO. Lo que se guarda no es un dato estable («esta
// charola tiene tira»), es uno que caduca: «esta tira está viva AHORA».
// Guardarlo cinco minutos ofrecería el botón de una tira que se desenchufó
// hace cuatro — y un botón que se pulsa y no enciende nada se deja de usar
// a la tercera vez.
const cache = new Map();
const VIGENCIA_MS = 20000;

export function dispositivosDe(codigo) {
  const guardado = cache.get(codigo);
  if (guardado && Date.now() - guardado.cuando < VIGENCIA_MS) return guardado.promesa;
  // El fallo se traga a propósito: si no se pudo saber si hay aparato, se
  // hace como si no lo hubiera. La ficha, la búsqueda y el asistente
  // funcionan exactamente igual sin luces.
  const promesa = api.get(`/dispositivos/para-ubicacion/${encodeURIComponent(codigo)}`)
    .catch(() => []);
  cache.set(codigo, { cuando: Date.now(), promesa });
  return promesa;
}

// Tras configurar o apagar algo, lo que se sabía del aparato ya no sirve.
export function olvidarDispositivos(codigo) {
  if (codigo) cache.delete(codigo);
  else cache.clear();
}
